import { useTranslation } from "react-i18next";

/**
 * Resolves a sidebar nav key to its translated label.
 *
 * The nav is data-driven (keys come from navConfig), so `t(key)` would be invisible to
 * i18next-parser and the keys would get pruned from the locale files. Listing them here as
 * literal `t("…")` calls (the useXxxLabel pattern) keeps them extracted and translatable.
 */
export const useNavLabel = () => {
  const { t } = useTranslation();
  const labels: Record<string, string> = {
    Overview: t("Overview"),
    Companies: t("Companies"),
    Needs: t("Needs"),
    Market: t("Market"),
    "Market surveys": t("Market surveys"),
    Procurements: t("Procurements"),
    Contracts: t("Contracts"),
    "New need": t("New need"),
    Inbox: t("Inbox"),
    "My needs": t("My needs"),
    "Needs overview": t("Needs overview"),
    "Approved needs": t("Approved needs"),
    "All procurements": t("All procurements"),
    "In progress": t("In progress"),
    Announced: t("Announced"),
    "Under evaluation": t("Under evaluation"),
    "Award and standstill": t("Award and standstill"),
    Completed: t("Completed"),
    "All contracts": t("All contracts"),
    "Active contracts": t("Active contracts"),
    "New procurement": t("New procurement"),
    "New contract": t("New contract"),
  };
  return (key: string): string => labels[key] ?? key;
};
